<section class="form-button-container">
  <div class="button-container">
    <button
      class="formBtn"
      [type]="inputType"
      [disabled]="isFormValid"
      [class.active]="!isFormValid"
      (click)="emitButtonClick()"
    >
      <span class="label" [class.active]="!isFormValid">{{ buttonText }}</span>
    </button>
  </div>
</section>
